export const Layouts = {
  DEFAULT: 'Default',
  EMPTY: 'Empty',
  ON_BOARDING: 'Onboarding',
  PAYMENT: 'Payment',
  IFRAME: 'IFrame',
  PRINT: 'Print',
}
